import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../store';

export function useProviderQuestionnaireState() {
  const {
    onboardingQuestionnairesLoading,
    sendQuestionnaireLoading,
    onboardingQuestionnaires,
  } = useSelector((state: RootState) => state.onboardingQuestionnaire);
  const {
    intakeQuestionnaires,
    intakeQuestionnairesLoading,
    sendIntakeQuestionnaireLoading,
  } = useSelector((state: RootState) => state.intakeQuestionnaire);

  return {
    loading:
      onboardingQuestionnairesLoading ||
      sendQuestionnaireLoading ||
      intakeQuestionnairesLoading ||
      sendIntakeQuestionnaireLoading,
    onboardingQuestionnairesLoading,
    onboardingQuestionnaires,
    sendQuestionnaireLoading,
    intakeQuestionnaires,
  };
}
